import z from "zod";


export interface LogisticDaysEntity {
    id: number;
    fecha: string;
    motivoBloqueo: string;
}

export interface LogisticDayToBlock {
    fecha: string;
    idEquipo: number;
    idTipoModulo: number;
    motivoBloqueo: string;
}

export interface SelectedDays{
    year: number;
    idEquipo: number;
    idTipoModulo: number;
    hasAll: boolean;
  };
export const logisticDaysSchema = z.object({
    year: z.any().optional(),
    idEquipo: z.any().optional(),
    idTipoModulo: z.any().optional(),
});

export const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];